import { createRoot } from 'react-dom/client';
import { getIdAttribute, getYesAttribute } from '@repo/widget-utils/attributes/attribute-helper';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';
import { BookingContextProvider } from 'src/widgets/BookingContext';
import PackageBooking from './PackageBooking';

class PackageBookingWidget extends BilberryCustomElement {
    protected renderWidget(): void {
        const packageId = getIdAttribute(this, false, 'package-id');
        const expandArrowInside = getYesAttribute(this, 'expand-arrow-inside');
        const positionOffscreen = getYesAttribute(this, 'position-offscreen');
        const dateSelectionFirst = getYesAttribute(this, 'date-selection-first');

        createRoot(this._mountPoint).render(
            <WidgetWrapper
                mountPoint={this._mountPoint}
                popoverMountPoint={this._popoverMountPoint}
                shadowRoot={this._shadowRoot}
            >
                <BookingContextProvider isBookingWidget={true}>
                    <PackageBooking
                        packageId={packageId}
                        expandArrowInside={expandArrowInside}
                        positionOffscreen={positionOffscreen}
                        dateSelectionFirst={dateSelectionFirst}
                    />
                </BookingContextProvider>
            </WidgetWrapper>,
        );
    }
}

export default function defineCustomElement() {
    customElements.define('bilberry-package-booking', PackageBookingWidget);
}
